const sanitizeWithoutSpaces = value => String(value || '').replace(/\s+/g, '');

const createGestorFilter = options => ({
  id: 'Gestor',
  type: 'searchSelect',
  label: 'Gestor',
  placeholder: 'Selecione o gestor',
  isMulti: true,
  showSelectAll: true,
  options
});

const createTipoTracaoFilter = options => ({
  id: 'TipoTracao',
  type: 'searchSelect',
  label: 'Modelo Veicular',
  placeholder: 'Selecione...',
  isMulti: true,
  showSelectAll: true,
  options
});

const createTipoReboqueFilter = options => ({
  id: 'TipoReboque',
  type: 'searchSelect',
  label: 'Modelo Veicular',
  placeholder: 'Selecione...',
  isMulti: true,
  showSelectAll: true,
  options
});

const createSegmentoVeiculoFilter = options => ({
  id: 'SegmentoVeiculo',
  type: 'searchSelect',
  label: 'Segmento Veiculo',
  placeholder: 'Selecione...',
  isMulti: true,
  showSelectAll: true,
  options
});

const createTipoOperacaoFilter = options => ({
  id: 'TipoOperacao',
  type: 'searchSelect',
  label: 'Tipo da Operacao',
  placeholder: 'Selecione...',
  isMulti: true,
  showSelectAll: true,
  options
});

const createPlotagemFilter = options => ({
  id: 'Plotagem',
  type: 'searchSelect',
  label: 'Plotagem',
  placeholder: 'Selecione...',
  isMulti: true,
  showSelectAll: true,
  options
});

const dataAgendamentoFilter = {
  id: 'DataAgendamento',
  type: 'datePicker',
  pickerType: 'datetime',
  label: 'Data Agendamento',
  placeholder: 'Selecione data e hora'
};

const dataInicioCarregamentoFilter = {
  id: 'DataInicioCarregamento',
  type: 'datePicker',
  pickerType: 'datetime',
  label: 'Data Carregamento',
  placeholder: 'Selecione data e hora'
};

const maisDeUmaCargaFilter = {
  id: 'MaisDeUmaCarga',
  type: 'checkbox',
  label: 'Somente itens com mais de uma carga',
  defaultValue: 'false'
};

export const getFilterConfigFrotaTracao = (
  gestorOptions = [],
  tipoTracaoOptions = [],
  segmentoVeiculoOptions = [],
  tipoOperacaoOptions = [],
  plotagemOptions = []
) => [
  {
    id: 'Frota',
    type: 'text',
    label: 'Frota',
    placeholder: 'Digite a frota',
    sanitizeValue: sanitizeWithoutSpaces
  },
  {
    id: 'Veiculo',
    type: 'text',
    label: 'Placa do Veiculo',
    placeholder: 'Digite a placa',
    sanitizeValue: sanitizeWithoutSpaces
  },
  createGestorFilter(gestorOptions),
  createTipoTracaoFilter(tipoTracaoOptions),
  createPlotagemFilter(plotagemOptions),
  dataAgendamentoFilter,
  dataInicioCarregamentoFilter,
  createSegmentoVeiculoFilter(segmentoVeiculoOptions),
  createTipoOperacaoFilter(tipoOperacaoOptions),
  {
    id: 'Carga',
    type: 'text',
    label: 'Carga',
    placeholder: 'Digite o numero da carga',
    sanitizeValue: sanitizeWithoutSpaces
  },
  {
    id: 'Disponivel',
    type: 'searchSelect',
    label: 'Status',
    placeholder: 'Selecione...',
    options: [
      {
        value: 'true',
        label: 'Disponivel'
      },
      {
        value: 'false',
        label: 'Indisponivel'
      }
    ]
  },
  {
    id: 'MensagemDisponibilidade',
    type: 'text',
    label: 'Mensagem Disponibilidade',
    placeholder: 'Digite a mensagem'
  },
  {
    id: 'StatusPatio',
    type: 'searchSelect',
    label: 'Status Patio',
    placeholder: 'Selecione...',
    isMulti: true,
    showSelectAll: true,
    options: [
      {
        value: '1',
        label: 'Disponiveis'
      },
      {
        value: '2',
        label: 'Indisponivel'
      },
      {
        value: '3',
        label: 'Em Rota'
      },
      {
        value: '4',
        label: 'Problemas Identificados'
      },
      {
        value: '5',
        label: 'Manutencao'
      }
    ]
  },
  maisDeUmaCargaFilter
];

export const getFilterConfigFrotaReboque = (
  gestorOptions = [],
  tipoReboqueOptions = [],
  segmentoVeiculoOptions = [],
  tipoOperacaoOptions = [],
  plotagemOptions = []
) => [
  {
    id: 'Frota',
    type: 'text',
    label: 'Frota',
    placeholder: 'Digite a frota',
    sanitizeValue: sanitizeWithoutSpaces
  },
  {
    id: 'Veiculo',
    type: 'text',
    label: 'Placa do Veiculo',
    placeholder: 'Digite a placa',
    sanitizeValue: sanitizeWithoutSpaces
  },
  createGestorFilter(gestorOptions),
  createTipoReboqueFilter(tipoReboqueOptions),
  createPlotagemFilter(plotagemOptions),
  dataAgendamentoFilter,
  dataInicioCarregamentoFilter,
  createSegmentoVeiculoFilter(segmentoVeiculoOptions),
  {
    id: 'Carga',
    type: 'text',
    label: 'Carga',
    placeholder: 'Digite o numero da carga',
    sanitizeValue: sanitizeWithoutSpaces
  },
  {
    id: 'Disponivel',
    type: 'searchSelect',
    label: 'Status',
    placeholder: 'Selecione...',
    options: [
      {
        value: 'true',
        label: 'Disponivel'
      },
      {
        value: 'false',
        label: 'Indisponivel'
      }
    ]
  },
  {
    id: 'MensagemDisponibilidade',
    type: 'text',
    label: 'Mensagem Disponibilidade',
    placeholder: 'Digite a mensagem'
  },
  {
    id: 'StatusPatio',
    type: 'searchSelect',
    label: 'Status Patio',
    placeholder: 'Selecione...',
    isMulti: true,
    showSelectAll: true,
    options: [
      {
        value: '1',
        label: 'Disponiveis'
      },
      {
        value: '2',
        label: 'Indisponivel'
      },
      {
        value: '3',
        label: 'Em Rota'
      },
      {
        value: '4',
        label: 'Problemas Identificados'
      },
      {
        value: '5',
        label: 'Manutencao'
      }
    ]
  },
  maisDeUmaCargaFilter
];
